import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const updateSurfaceProtocolNodeMutation = gql`
  mutation updateSurfaceProtocolNode($input: UpdateSurfaceProtocolNodeInput!) {
    updateSurfaceProtocolNode(input: $input) {
      success
      error
      data {
        ...surfaceNodeUnionDetails
      }
    }
  }
  ${surfaceUnionFragment}
`;

export default mutation(updateSurfaceProtocolNodeMutation);
